module.exports = __webpack_public_path__ + "img/home_bgv2-1.2f04bacd.png";